import { Component } from '@angular/core';
import { ButtonIconSet, ButtonIconType, SecondaryButtonIconType } from '../../../common-components/buttons/buttons.types';

@Component({
  selector: 'app-buttons-playground',
  templateUrl: './buttons-playground.component.html',
  styleUrls: ['./buttons-playground.component.scss'],
})
export class ButtonsPlaygroundComponent {
  // Filled primary
  filledLabel = 'Guardar';
  filledIcon = 'save';
  filledDisabled = false;
  filledTypeIcon: ButtonIconType = 'rounde';
  filledIconSet: ButtonIconSet = 'material-symbols-rounded';
  filledIconPosition = true;

  // Outlined
  outlinedLabel = 'Cancelar';
  outlinedIcon = 'close';
  outlinedDisabled = false;
  outlinedTypeIcon: ButtonIconType = 'rounde';
  outlinedIconSet: ButtonIconSet = 'material-symbols-rounded';
  outlinedIconPosition = true;

  // Text (sin borde; sin overlay de fondo en hover)
  textLabel = 'Omitir';
  textIcon = 'arrow_forward';
  textDisabled = false;
  textTypeIcon: ButtonIconType = 'rounde';
  textIconSet: ButtonIconSet = 'material-symbols-rounded';
  textIconPosition = true;

  // Secondary filled
  secondaryLabel = 'Secundario';
  secondaryIcon = 'add';
  secondaryDisabled = false;
  secondaryTypeIcon: SecondaryButtonIconType = 'rounde';
  secondaryIconSet: ButtonIconSet = 'material-symbols-rounded';
  secondaryIconPosition = true;

  clickLog = '';

  log(name: string): void {
    this.clickLog = `${name} @ ${new Date().toLocaleTimeString()}`;
  }

  readonly typeIcons = ['outlined', 'rounde'] as const;
  readonly secondaryTypeIcons = ['outlined', 'rounde', 'customized'] as const;
  readonly iconSets = ['material-symbols-rounded', 'material-icons', 'material-icons-outlined'] as const;
}
